import { IModel } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from './linkedservice';

import { AzureKeyVault } from './key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { shellStringResources, IViolation, Credential } from 'shell-models-lib';
import { AuthenticationType } from 'app/interfaces/IAuthenticationType';

@Metamodel.model({
    name: adfModelTypeMap.azureDataLakeStoreGen2CosmosStructuredStream.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.AzureDataLakeStoreGen2CosmosStructuredStream_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.AzureDataLakeStoreGen2CosmosStructuredStream_DisplayText)
    ]
})
export class AzureDataLakeStoreGen2CosmosStructuredStreamLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.ModelName_Url
    })
    public url: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalID
    })
    public servicePrincipalId: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalKey,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public servicePrincipalKey?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_StorageAccountKey,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public accountKey?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_Tenant
    })
    public tenant: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType
    })
    public authenticationType?: string;

    @Metamodel.attribute({
        display: shellStringResources.Credential,
        reference: true,
        constraint: {
            validator: AzureDataLakeStoreGen2CosmosStructuredStreamLinkedService.validateCredential
        }
    })
    public credential?: Credential;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    private static validateCredential(linkedservice: AzureDataLakeStoreGen2CosmosStructuredStreamLinkedService, referencedCredential: Credential): IViolation[] | undefined {
        if (linkedservice &&
            linkedservice.authenticationType === AuthenticationType.Credential &&
            !referencedCredential) {
            return [{
                context: linkedservice,
                message: () => shellStringResources.Error_InvalidCredentialReferenced
            }];
        }
        return undefined;
    }
}
